import { Client } from "@seneca/client-library";

export default class LiveFeedServiceClient extends Client {
  async fetchFeedEvents(userId: string) {
    const url = `${this.url}/api/live-feed-events/${userId}`;
    const expectedResponses = [200, 403];

    const response = await this.requestMaker.makeRequest<any>(
      url,
      { method: "GET" },
      expectedResponses
    );

    return response.json;
  }
}
